import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import '../Header.css';
import { fetchInitialData } from "../../fetchData";
import Service from '../../service/Service';
import * as actions from './Actions';
import QnaSection from "./QnaSection";
import MemoriesSection from "./MemoriesSection";
import VideoSection from "./VideoSection";
import BabyNamesSection from "./BabyNamesSection";
import ReadSection from "./ReadSection";
import CommonSection from "./CommonSection";
import VaccinationSection from "./VaccinationSection";
import GrowthTkrSection from "./GrowthTkrSection";
import BabyTeethingSection from "./BabyTeethingSection";
import GroupsSection from "./GroupsSection";
import BabySizeCompSection from "./BabySizeCompSection";
import DiscussionSection from "./DiscussionSection";
import PISsection from "./PISsection";
import withContext from "../../../withContext";
const service = new Service();

class SearchResult extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let searchData = [];
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            searchData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                searchData = props.staticContext.initialData['initialData'];
            }
        }
        console.log("searchData:::", searchData);
        if(searchData && searchData['msg'] == "1" && searchData['result']){
            initialData = searchData['result'];
        }
        
        var searchType = this.props.location.pathname.split('/')[2].split('-').join(' ');
        this.searchType = searchType;
        var searchkey = this.props.location.pathname.split("/")[3].split('-').join(' ');
        this.searchTerm = searchkey;
        var metasearchType;
        if (searchType && searchType !== "all") {
            for (let i = 0; i < initialData.length; i++) {
                if (
                    searchType.toUpperCase() === initialData[i].type?.toUpperCase()
                ) {
                    searchType = initialData[i].title;
                    metasearchType = initialData[i].title;
                    break;
                }
            }
        } else {
            metasearchType = 'Search Result';
        }
        
        // if(searchType != "all"){
        //     for (let i = 0; i < initialData.length; i++) {
        //         if(searchType.toUpperCase() == initialData[i].type.toUpperCase()){
        //             searchType = initialData[i].title;
        //             metasearchType = initialData[i].title;
        //             break;
        //         }
        //     }
        // } else{
        //     metasearchType = 'Search Result';
        // }
        
        this.state = {
            searchData : initialData,
            metaTitle: `${searchkey} - ${metasearchType} | FirstCry Parenting`,
            qnapageNo : 0,
            articlepageNo : 0,
            babynamepageNo : 0,
            videopageNo : 0,
            mempageNo : 0,
            grppageNo: 0,
            pispageNo: 0,
            dietPlanspageNo: 0,
            pegdietPlanspageNo: 0,
            babyGrtpageNo: 0,
            pregweekpageNo: 0,
            vaccpageNo: 0,
            discpageNo: 0,
            teethpageNo: 0,
            searchTerm : searchkey,
            searchType : searchType
        }
    }

    static initialAction(reqUrl, ftk, authData, uId, childData, cookie) {
         var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }

        let url = global.api_url + "getuniversalsearchtools";
        let searchType = (reqUrl.split('/')[2]).split('-').join(' ').toLowerCase();
        let searchkey = reqUrl.split('/')[3].split('-').join(' ');
        let postdata;
        if(searchType == "all"){
            postdata = {
                "pagesize" : 3,
                "pageno" : 1,
                "searchkey" : searchkey
            }
        } else {
            postdata = {
                "pagesize" : 3,
                "pageno" : 1,
                "searchkey" : searchkey,
                "type": searchType
            }
        }
        let body = JSON.stringify(postdata);
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    componentDidMount() {
        // debugger;
        document.addEventListener("click", actions.domClick);
        // var searchType = window.location.pathname.split('/')[2].split('-').join(' ');
        // var searchkey = window.location.pathname.split("/")[3].split('-').join(' ');
        // this.searchTerm = searchkey;
        // this.searchType = searchType;
        // this.setState({ searchTerm : searchkey, searchType : searchType });

        if (navigator.onLine) {
            if (!this.state.searchData || (this.state.searchData && this.state.searchData.length < 1)) {
                service.showLoader();
                this.getSearchData();
            } else {
                localStorage.setItem('searchData', JSON.stringify(this.state.searchData));
                var searchdata = JSON.parse(localStorage.getItem('searchData'));
            }
        } else {
            if (localStorage.getItem('searchData')) {
                var searchdata = JSON.parse(localStorage.getItem('searchData'));
                this.setState({ 
                    searchData: searchdata
                });
            }
            service.hideLoader();
        }
    }

    getSearchData(){
        // debugger;
        var searchType = window.location.pathname.split('/')[2].split('-').join(' ');
        var searchkey = window.location.pathname.split("/")[3].split('-').join(' ');
        var url = global.api_ci_url + "UniversalSearch/getUniversalSearchData";
        if(searchType == "all"){
            var postdata = {
                "pagesize" : 3,
                "pageno" : 1,
                "searchkey" : searchkey
            }
        }else{
            var postdata = {
                "pagesize" : 3,
                "pageno" : 1,
                "searchkey" : searchkey,
                "type": searchType
            }
        }
        service.postServiceCall(url, postdata).then((json) => {
            if (json['msg'] == "1") {
                this.setState({ 
                    searchData: json['result']
                });
                localStorage.setItem('searchData', JSON.stringify(json['result']));
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    getMoreSearchData(type){
        // debugger;
        // if(global.ftk){
            var url = global.api_ci_url + "UniversalSearch/getUniversalSearchData";
            var newpageNo;
            if(type == 'qna'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmoreque'
                newpageNo = this.state.qnapageNo + 1;
                this.setState({ qnapageNo : newpageNo});
            } else if(type == 'articles'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmorearticles'
                newpageNo = this.state.articlepageNo + 1;
                this.setState({ articlepageNo : newpageNo});
            } else if(type == 'babynames'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmorenames'
                newpageNo = this.state.babynamepageNo + 1;
                this.setState({ babynamepageNo : newpageNo});
            } else if(type == 'videos'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmorevideos'
                newpageNo = this.state.videopageNo + 1;
                this.setState({ videopageNo : newpageNo});
            } else if(type == 'memories'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmorememory'
                newpageNo = this.state.mempageNo + 1;
                this.setState({ mempageNo : newpageNo});
            } else if(type == 'groups'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmoregroups'
                newpageNo = this.state.grppageNo + 1;
                this.setState({ grppageNo : newpageNo});
            } else if(type == 'PregnancyInspectionSchedule'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmorevccpis';
                newpageNo = this.state.pispageNo + 1;
                this.setState({ pispageNo : newpageNo});
            } else if(type == 'dietPlan'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmoredietplan';
                newpageNo = this.state.dietPlanspageNo + 1;
                this.setState({ dietPlanspageNo : newpageNo});
            } else if(type == 'pregnancyDiet'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmorepregnency';
                newpageNo = this.state.pegdietPlanspageNo + 1;
                this.setState({ pegdietPlanspageNo : newpageNo});
            } else if(type == 'babyGroth'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmoredietplan';
                newpageNo = this.state.babyGrtpageNo + 1;
                this.setState({ babyGrtpageNo : newpageNo});
            } else if(type == 'pregnancyweek'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmorepregnency';
                newpageNo = this.state.pregweekpageNo + 1;
                this.setState({ pregweekpageNo : newpageNo});
            } else if(type == 'vaccination'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmorevccpis';
                newpageNo = this.state.vaccpageNo + 1;
                this.setState({ vaccpageNo : newpageNo});
            } else if(type == 'discussions'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmorediscussion'
                newpageNo = this.state.discpageNo + 1;
                this.setState({ discpageNo : newpageNo});
            } else if(type == 'babyTeething'){
                var url = global.api_ci_url + 'api/fetchfromCI/getsearchmoreteething';
                newpageNo = this.state.teethpageNo + 1;
                this.setState({ teethpageNo : newpageNo});
            }
            var postdata = {
                "pagesize" : 10,
                "pageno" : newpageNo,
                "searchkey" : this.state.searchTerm
            }
            if(type == 'PregnancyInspectionSchedule'){
                postdata = {
                    "pagesize" : 10,
                    "pageno" : newpageNo,
                    "searchkey" : this.state.searchTerm,
                    "type": "pis"
                }
            } else if(type == 'vaccination'){
                postdata = {
                    "pagesize" : 10,
                    "pageno" : newpageNo,
                    "searchkey" : this.state.searchTerm,
                    "type": "vcc"
                }
            } else if(type == 'babyGroth'){
                postdata = {
                    "pagesize" : 10,
                    "pageno" : newpageNo,
                    "searchkey" : this.state.searchTerm,
                    "type": "grothdevelopment"
                }
            } else if(type == 'dietPlan'){
                postdata = {
                    "pagesize" : 10,
                    "pageno" : newpageNo,
                    "searchkey" : this.state.searchTerm,
                    "type": "dietPlan"
                }
            } else if(type == 'pregnancyweek'){
                postdata = {
                    "pagesize" : 10,
                    "pageno" : newpageNo,
                    "searchkey" : this.state.searchTerm,
                    "type": "pregnancyweek"
                }
            } else if(type == 'pregnancyDiet'){
                postdata = {
                    "pagesize" : 10,
                    "pageno" : newpageNo,
                    "searchkey" : this.state.searchTerm,
                    "type": "pregnancydiet"
                }
            }



            service.postServiceCall(url, postdata).then((json) => {
                // debugger;
                if (json['msg'] == "1") {
                    for (var i of Object.keys(json['result'])) {
                        if(json['result'][i]['type'] == type){
                            var newData = this.state.searchData;
                        
                        for (var j of Object.keys(newData)){
                            if(newData[j]['type'] == type){
                                if(newpageNo > 1){
                                    newData[j]['search_cnt'] = json['result'][i]['search_cnt'];
                                    if(type=='articles'){
                                        newData[j]['article'] = newData[j]['article'].concat(json['result'][i]['article']);
                                    } else if(type=='babynames'){
                                        newData[j]['babyNames'] = newData[j]['babyNames'].concat(json['result'][i]['babyNames']);
                                    } else if(type=='memories'){
                                        newData[j]['memories'] = newData[j]['memories'].concat(json['result'][i]['memories']);
                                    } else if(type=='qna'){
                                        newData[j]['data'] = newData[j]['data'].concat(json['result'][i]['data']);
                                    } else if(type=='videos'){
                                        newData[j]['video'] = newData[j]['video'].concat(json['result'][i]['video']);
                                    } else if(type == 'groups'){
                                        newData[j]['groups'] = newData[j]['groups'].concat(json['result'][i]['groups']);
                                    } else if(type == 'PregnancyInspectionSchedule'){
                                        newData[j]['data'] = newData[j]['data'].concat(json['result'][i]['data']);
                                    } else if(type == 'dietPlan'){
                                        newData[j]['dietPlanTools'] = newData[j]['dietPlanTools'].concat(json['result'][i]['dietPlanTools']);
                                    } else if(type == 'pregnancyDiet'){
                                        newData[j]['PregnancyDietPlanTools'] = newData[j]['PregnancyDietPlanTools'].concat(json['result'][i]['PregnancyDietPlanTools']);
                                    } else if(type == 'babyGroth'){
                                        newData[j]['babyGrothDevTools'] = newData[j]['babyGrothDevTools'].concat(json['result'][i]['babyGrothDevTools']);
                                    } else if(type == 'pregnancyweek'){
                                        newData[j]['PregnancyWeekByWeekTools'] = newData[j]['PregnancyWeekByWeekTools'].concat(json['result'][i]['PregnancyWeekByWeekTools']);
                                    } else if(type == 'vaccination'){
                                        newData[j]['vaccination'] = newData[j]['vaccination'].concat(json['result'][i]['vaccination']);
                                    } else if(type == 'discussions'){
                                        newData[j]['discussion'] = newData[j]['discussion'].concat(json['result'][i]['discussion']);
                                    } else if(type == 'babyTeething'){
                                        newData[j]['tooth'] = newData[j]['tooth'].concat(json['result'][i]['tooth']);
                                    }
                                } else {
                                    newData[j] = json['result'][i];
                                }
                                this.setState({ searchData: newData });
                                break;
                            }
                        }
                        break;
                    }
                }
            }
            }).catch((error) => {
                console.error(error);
            });
        // }
        // else{
        //     service.showAlert("Please Login");
        //     window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        //     return false;
        // }
    }


    qnaMoreSearchData(type){
        // debugger;
        // if(global.ftk){
            // var url = global.api_ci_url + "UniversalSearch/getUniversalSearchData";
            var url = global.api_ci_url + 'api/fetchfromCI/getsearchmoreque'
            var newpageNo;
                newpageNo = this.state.qnapageNo + 1;
                this.setState({ qnapageNo : newpageNo});
                
            var postdata = {
                "pagesize" : 10,
                "pageno" : newpageNo,
                "searchkey" : this.state.searchTerm
            }
            service.postServiceCall(url, postdata).then((json) => {
                // debugger;
                if (json['msg'] == "1") {
                    for (var i of Object.keys(json['result'])) {
                        if(json['result'][i]['type'] == type){
                            var newData = this.state.searchData;
                        
                        for (var j of Object.keys(newData)){
                            if(newData[j]['type'] == type){
                                if(newpageNo > 1){
                                    newData[j]['search_cnt'] = json['result'][i]['search_cnt'];
                                    if(type=='qna'){
                                        newData[j]['data'] = newData[j]['data'].concat(json['result'][i]['data']);
                                    }
                                } else {
                                    newData[j] = json['result'][i];
                                }
                                this.setState({ searchData: newData });
                                break;
                            }
                        }
                        break;
                    }
                }
            }
            }).catch((error) => {
                console.error(error);
            });
        // }
        // else{
        //     service.showAlert("Please Login");
        //     window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        //     return false;
        // }
    }
    
    // changeData(id, type, status) {
        //     let videoData = this.state.videoData;
        //     videoData && videoData.forEach((video) => {
            //         if (video.id == id) {
                //             if (type == "view") {
    //                 if (parseInt(status) == 1) {
    //                     video.viewCount = parseInt(video.viewCount) + 1;
    //                 }
    //             } else if (type == "like") {
    //                 if (parseInt(status) == 1) {
    //                     video.isLike = true;
    //                     video.likeCount = parseInt(video.likeCount) + 1;
    //                 } else if (parseInt(status) == 0) {
    //                     video.isLike = false;
    //                     video.likeCount = parseInt(video.likeCount) - 1;
    //                 }
    //             } 
    //             // else if (type == "bookmark") {
    //             //     if (parseInt(status) == 1) {
    //             //         video.isBookmarked = true;
    //             //         video.bookmarkCount = parseInt(video.bookmarkCount) + 1;
    //             //     } else if (parseInt(status) == 0) {
    //             //         video.isBookmarked = false;
    //             //         // video.bookmarkCount = parseInt(video.bookmarkCount) - 1;
    //             //     }
    //             // }
    //         }
    //     });
    //     this.setState({ videoData: videoData });
    // }

    // setBookMark(videoId, status) {
    //     if (global.ftk != '') {
    //         service.showLoader();
    //         var postData = {
    //             "videoId": videoId,
    //             "status": status.toString()
    //         }
    //         var url = global.api_ci_url + "Videos/setBookMark";
    //         service.postServiceCall(url, postData).then((json) => {
    //             console.log(json);
    //             if (json['msg'] == "1") {
    //                 this.changeData(videoId, "bookmark", status);
    //             }
    //             service.hideLoader();
    //         }).catch((error) => {
    //             console.error(error);
    //             service.hideLoader();
    //         });
    //         return true;
    //     } else {
    //         service.showAlert("Please Login");
    //         window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    //         return false;
    //     }
    // }

    render() {
        return (
            <main className="searchresult main-container center-container">
                <Helmet
                    title= {this.state.metaTitle}
                    meta={[
                        { "name" : "robots", "content" : "noindex"}
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        {this.state.searchType != "all" &&
                        <span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>{this.state.searchType}</span></span>
                        }
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>{this.searchTerm}</span>
                    </div>
                    {this.state.searchType != "all" ?
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>{this.searchTerm} - {this.state.searchType}</h1>
                    :
                    <h1 className="B24_00" id="skipToH1" tabIndex={0}>{this.searchTerm}</h1>
                    }
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="search-result-wrapper">
                            
                        {this.state.searchData && this.state.searchData.map((search, index) => 
                            search && search.type && search.type=='qna' ? 
                            <QnaSection key={index} qnaData={search} eleRef={this} /> 
                            : 
                            search && search.type && search.type=='articles' ?
                            <ReadSection key={index} readData={search} eleRef={this} />
                            :
                            search && search.type && search.type=='memories' ?
                            <MemoriesSection key={index} memoryData={search} eleRef={this} />
                            :
                            search && search.type && search.type=='videos' ?
                            <VideoSection key={index} videoData={search} eleRef={this} />
                            :
                            search && search.type && search.type=='babynames' ? 
                            <BabyNamesSection key={index} babynamesData={search} eleRef={this} />
                            :
                            search && search.type && search.type=='dietPlan' ?
                            <section key={index} className="babydiet-section">
                                <div className="section-title">Baby diet plan</div>
                                <CommonSection section="babydiet" sectionData={search} data={search.dietPlanTools} eleRef={this}/>
                            </section>
                            :
                            search && search.type && search.type=='pregnancyDiet' ?
                            <section key={index} className="pregdiet-section">
                                <div className="section-title">Pregnancy diet plan</div>
                                <CommonSection section="pregnancydiet" sectionData={search} data={search.PregnancyDietPlanTools} eleRef={this} />
                            </section>
                            :
                            search && search.type && search.type=='babyGroth' ?
                            <section key={index} className="g&d-section">
                                <div className="section-title">Baby Growth & Development</div>
                                <CommonSection section="g&d" sectionData={search} data={search.babyGrothDevTools} eleRef={this} />
                            </section>
                            :
                            search && search.type && search.type=='pregnancyweek' ?
                            <section key={index} className="pregweek-section">
                                <div className="section-title">Pregnancy Week by Week</div>
                                <CommonSection section="pregweek" sectionData={search} data={search.PregnancyWeekByWeekTools} eleRef={this} />
                            </section>
                            :
                            search && search.type && search.type=='vaccination' ?
                            <VaccinationSection key={index} vaccData={search} eleRef={this}/>
                            :
                            search && search.type && search.type=='babyTeething' ?
                            <BabyTeethingSection key={index} teethingData={search} eleRef={this}/>
                            :
                            search && search.type && search.type=='groups' ?
                            <GroupsSection key={index} groupData={search} eleRef={this}/>
                            :
                            search && search.type && search.type=='babySizeCompair' ?
                            <BabySizeCompSection key={index} sizeCompData={search} eleRef={this}/>
                            :
                            search && search.type && search.type=='growthtracker' ?
                            <GrowthTkrSection key={index} growthData={search} eleRef={this}/>
                            :
                            search && search.type && search.type=='discussions' ?
                            <DiscussionSection key={index} discuData={search} eleRef={this} />
                            : 
                            search && search.type && search.type=='PregnancyInspectionSchedule' ?
                            <PISsection key={index} pisData={search} eleRef={this} />
                            : null
                        )}
                        
                        <div className="share-overlay"></div>
                        </div>
                    </div>
                </div>
            </main>
        )
    }
}

export default withContext(SearchResult);
